(function () {
  function getEndpoint(el) {
    return (
      el.getAttribute("data-endpoint") ||
      document.body.getAttribute("data-ashna-endpoint") ||
      ""
    ).trim();
  }

  function normalizeValue(value) {
    return value == null ? "" : String(value).trim();
  }

  async function postLead(endpoint, type, data) {
    if (!endpoint) {
      throw new Error("Missing endpoint. Set `data-endpoint` or `data-ashna-endpoint`.");
    }

    const response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: type,
        data: data,
        website: "",
      }),
    });

    const payload = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(payload.error || "Something went wrong. Please try again.");
    }

    return payload;
  }

  function setStatus(target, message, state) {
    if (!target) return;
    target.textContent = message;
    target.setAttribute("data-state", state || "idle");
  }

  function disableSubmit(form, disabled) {
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = !!disabled;
  }

  function collectFormData(form) {
    var formData = new FormData(form);
    var data = {};

    formData.forEach(function (value, key) {
      data[key] = normalizeValue(value);
    });

    return data;
  }

  function attachForm(form) {
    if (form.__ashnaBound) return;
    form.__ashnaBound = true;

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var endpoint = getEndpoint(form);
      var type = form.getAttribute("data-type");
      var status = form.querySelector(".ashna-lead-status");
      var success = form.getAttribute("data-success") || "Thanks, your request has been submitted.";
      var data = collectFormData(form);

      try {
        disableSubmit(form, true);
        setStatus(status, "Sending...", "pending");
        await postLead(endpoint, type, data);
        setStatus(status, success, "success");
        form.reset();
      } catch (err) {
        setStatus(status, err.message || "Unable to submit.", "error");
      } finally {
        disableSubmit(form, false);
      }
    });
  }

  function ensureModal() {
    var existing = document.getElementById("ashna-lead-modal");
    if (existing) return existing;

    var modal = document.createElement("div");
    modal.id = "ashna-lead-modal";
    modal.className = "ashna-lead-modal";
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ashna-lead-modal__backdrop" data-close="1"></div>' +
      '<div class="ashna-lead-modal__panel" role="dialog" aria-modal="true" aria-label="Lead form">' +
      '<button type="button" class="ashna-lead-modal__close" data-close="1" aria-label="Close">x</button>' +
      '<div class="ashna-lead-modal__content"></div>' +
      "</div>";

    modal.addEventListener("click", function (event) {
      if (event.target && event.target.getAttribute("data-close") === "1") {
        closeModal(modal);
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function closeModal(modal) {
    modal.hidden = true;
    var content = modal.querySelector(".ashna-lead-modal__content");
    if (content) content.innerHTML = "";
  }

  function escapeHtml(str) {
    return normalizeValue(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildModalFormHtml(type, trigger, endpoint) {
    var productTitle = trigger.getAttribute("data-product-title") || "";
    var productHandle = trigger.getAttribute("data-product-handle") || "";
    var productUrl = trigger.getAttribute("data-product-url") || "";
    var variantId = trigger.getAttribute("data-variant-id") || "";
    var variantTitle = trigger.getAttribute("data-variant-title") || "";

    if (type === "sold_out_notify") {
      return (
        '<h3 class="ashna-lead-title">Notify me when available</h3>' +
        '<p class="ashna-lead-copy">' +
        escapeHtml(productTitle || "Selected product") +
        "</p>" +
        '<form class="ashna-lead-form" data-type="sold_out_notify" data-endpoint="' +
        escapeHtml(endpoint) +
        '" data-success="You are on the list. We will notify you when available.">' +
        '<label class="ashna-sr-only">Email</label><input type="email" name="email" placeholder="Email *" required />' +
        '<input type="hidden" name="productTitle" value="' +
        escapeHtml(productTitle) +
        '" />' +
        '<input type="hidden" name="productHandle" value="' +
        escapeHtml(productHandle) +
        '" />' +
        '<input type="hidden" name="productUrl" value="' +
        escapeHtml(productUrl) +
        '" />' +
        '<input type="hidden" name="variantId" value="' +
        escapeHtml(variantId) +
        '" />' +
        '<input type="hidden" name="variantTitle" value="' +
        escapeHtml(variantTitle) +
        '" />' +
        '<button type="submit">Notify me</button>' +
        '<p class="ashna-lead-status" aria-live="polite"></p>' +
        "</form>"
      );
    }

    return (
      '<h3 class="ashna-lead-title">Price inquiry</h3>' +
      '<p class="ashna-lead-copy">' +
      escapeHtml(productTitle || "Selected exclusive item") +
      "</p>" +
      '<form class="ashna-lead-form" data-type="price_inquiry" data-endpoint="' +
      escapeHtml(endpoint) +
      '" data-success="Your inquiry has been sent. We will contact you shortly.">' +
      '<label class="ashna-sr-only">Name</label><input type="text" name="name" placeholder="Name" required />' +
      '<label class="ashna-sr-only">Email</label><input type="email" name="email" placeholder="Email *" required />' +
      '<label class="ashna-sr-only">Phone</label><input type="tel" name="phone" placeholder="Phone number" />' +
      '<label class="ashna-sr-only">Message</label><textarea name="message" rows="4" placeholder="Comment"></textarea>' +
      '<input type="hidden" name="productTitle" value="' +
      escapeHtml(productTitle) +
      '" />' +
      '<input type="hidden" name="productHandle" value="' +
      escapeHtml(productHandle) +
      '" />' +
      '<input type="hidden" name="productUrl" value="' +
      escapeHtml(productUrl) +
      '" />' +
      '<button type="submit">Send inquiry</button>' +
      '<p class="ashna-lead-status" aria-live="polite"></p>' +
      "</form>"
    );
  }

  function attachModalTriggers() {
    var triggers = document.querySelectorAll(".ashna-open-lead-modal");

    triggers.forEach(function (trigger) {
      if (trigger.__ashnaBound) return;
      trigger.__ashnaBound = true;

      trigger.addEventListener("click", function (event) {
        event.preventDefault();

        var endpoint = getEndpoint(trigger);
        var type = trigger.getAttribute("data-type") || "sold_out_notify";
        var modal = ensureModal();
        var content = modal.querySelector(".ashna-lead-modal__content");

        content.innerHTML = buildModalFormHtml(type, trigger, endpoint);
        content.querySelectorAll(".ashna-lead-form").forEach(attachForm);
        modal.hidden = false;
      });
    });
  }

  function init() {
    document.querySelectorAll(".ashna-lead-form").forEach(attachForm);
    attachModalTriggers();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
